import React from "react";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { useMount } from "react-use";

type Props = {
  name: string;
};

const TrackPageView: React.FC<Props> = (props) => {
  const { name } = props;

  const appInsights = useAppInsightsContext();

  useMount(() => {
    appInsights.trackPageView({ name });
  });

  return null;
};

export default TrackPageView;
